import React, { useCallback, useContext, useEffect, useState, useRef } from 'react'
import { PropertyCardSliderDefaultImg } from '../../helper/imagepath'
import { useNavigate } from 'react-router-dom'
import DeletePopup from '../../component/deletePopup'
import { useDispatch, useSelector } from 'react-redux'
import { deleteProperty, getAllProperty } from '../../redux/slices/propertySlice'
import { SpinnerContext } from '../../context/spinnerContext'
import Carousel from 'react-bootstrap/Carousel'
import calender from '../../assets/img/calendar.svg'
import search_box_img from '../../assets/img/search_box_img.png'
import add_icon from '../../assets/img/Add icon.png'
import trash from '../../assets/img/trash.png'
import { errorToast, successToast } from '../../util/Toast/toast'
import { appendImageURL } from '../../helper/function'
import { FREEZE_CLIENT_MSG, NoFoundText } from '../../util/constant'
import Pagination from '../../component/common/pagination'
import NoDataFound from '../../component/noDataFound'

const PropertyPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => auth)
  const { allProperty } = useSelector(({ property }) => property)
  const { changeLoader } = useContext(SpinnerContext)
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 6
  const [propertyID, setPropertyID] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [loading, setLoading] = useState(true)

  const debounceRef = useRef(null)

  const openDeleteModal = () => setIsDeleteModalOpen((prev) => !prev)

  const onDelete = () => {
    if (propertyID) {
      setIsRefresh(false)
      changeLoader(true)
      dispatch(deleteProperty(propertyID)).then(({ payload }) => {
        changeLoader(false)
        openDeleteModal()
        if (payload?.status === 200) {
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
        }
      })
    }
  }

  const handleSearch = useCallback((value) => {
    clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setDebouncedSearchTerm(value)
      setCurrentPage(1)
      setIsRefresh(true)
    }, 1800)
  }, [])

  useEffect(() => {
    if (!isRefresh) return
    const params = {
      is_pagination: true,
      page: currentPage,
      limit: itemsPerPage,
      sort_column: 'created_at',
      sort_order: 'DESC',
      ...(debouncedSearchTerm && { search: debouncedSearchTerm })
    }

    setLoading(true)
    changeLoader(true)
    dispatch(getAllProperty(params))
      .then(() => {
        setTimeout(() => {
          setLoading(false)
        }, 1000)

        changeLoader(false)
      })
      .catch((err) => {
        console.error('Error fetching properties:', err)
        setTimeout(() => {
          setLoading(false)
        }, 1000)
        changeLoader(false)
      })
    setIsRefresh(false)
  }, [debouncedSearchTerm, itemsPerPage, currentPage, isRefresh])

  const handlePageChange = (selectedItem) => {
    setIsRefresh(true)
    setCurrentPage(selectedItem.selected + 1)
  }

  const onNavigateEditPage = (event, properties_id) => {
    event.preventDefault()
    navigate(`/edit-property/${properties_id}`)
  }

  return (
    <>
      <div className="page-wrapper">
        <div>
          <div className="searchbox_sec">
            <div className="property_sec">
              <div className="searchbar">
                <div className="text-center w-100">
                  <input
                    className="Search_properties_text"
                    type="text"
                    placeholder="Search Properties"
                    onChange={(e) => {
                      setSearchTerm(e.target.value)
                      handleSearch(e.target.value)
                    }}
                    value={searchTerm}
                  />
                </div>
                <div className="search_btn_bg">
                  <img className="search_box_img" src={search_box_img} alt="Search" />
                </div>
              </div>
            </div>
            <button
              className="property_btn btn btn-primary"
              onClick={() => {
                if (user?.is_freezed_client) {
                  errorToast(FREEZE_CLIENT_MSG)
                  return
                } else if (user?.is_email_verified && user?.is_term_accepted && !user?.is_freezed_client) {
                  navigate('/add-property')
                } else if (!user?.is_term_accepted) {
                  errorToast('To add a new property to our platform, you must accept our Terms and Conditions')
                } else if (!user?.is_email_verified) {
                  errorToast('Email not verified. Please verify email to continue')
                }
              }}
            >
              <img src={add_icon} alt="Add" /> <span>Add Property</span>
            </button>
          </div>
          {loading ? (
            <></>
          ) : allProperty?.totalRecords > 0 ? (
            <>
              <div className="property_sec_bgbox">
                <div className="row">
                  {allProperty?.properties?.map((property) => (
                    <div className="col-md-6 col-lg-6 col-xl-4 mb-3" key={property?.properties_id}>
                      <div className="property_sec_box">
                        <div className="slider_main_div">
                          <Carousel data-bs-theme="dark">
                            {property?.property_image?.length > 0 ? (
                              property.property_image.map((image, index) => (
                                <Carousel.Item
                                  key={index}
                                  onClick={(e) => {
                                    onNavigateEditPage(e, property?.properties_id)
                                  }}
                                >
                                  <img
                                    className="property_slider_img"
                                    src={image ? appendImageURL(image) : PropertyCardSliderDefaultImg}
                                    alt="Property"
                                  />
                                </Carousel.Item>
                              ))
                            ) : (
                              <Carousel.Item
                                onClick={(e) => {
                                  onNavigateEditPage(e, property?.properties_id)
                                }}
                              >
                                <img className="property_slider_img" src={PropertyCardSliderDefaultImg} alt="Default" />
                              </Carousel.Item>
                            )}
                          </Carousel>
                          {!user?.is_freezed_client && (
                            <div
                              className="trash_btn"
                              onClick={(e) => {
                                e.stopPropagation()
                                setPropertyID(property?.properties_id)
                                openDeleteModal()
                              }}
                            >
                              <img className="trash_img" src={trash} alt="Delete" />
                            </div>
                          )}
                        </div>
                        <div
                          className="property_content_main_div"
                          onClick={(e) => {
                            onNavigateEditPage(e, property?.properties_id)
                          }}
                        >
                          <h3 className="property_slider_sec_title">{property?.property_name}</h3>
                          <p className="property_slider_sec_subtitle">{property?.address}</p>
                          <div className="slider_data_border"></div>
                          <div className="d-flex align-content-center gap-2">
                            <img className="calender" src={calender} alt="Calendar" />
                            <span className="property_slider_sec_schedule">Schedule</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {allProperty?.totalRecords > 0 && (
                <Pagination
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  totalPages={allProperty?.totalPage || 0}
                  itemsPerPage={itemsPerPage}
                />
              )}
            </>
          ) : (
            <NoDataFound title={NoFoundText.PROPERTIES} />
          )}
        </div>
      </div>

      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={openDeleteModal}>
              Cancel
            </button>
            <button type="submit" className="btn btn-danger common-field-btn w-100" onClick={onDelete}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default PropertyPage
